import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './features/LoginPage';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ProtectedRoute from './common/ProtectedRoute';
import { NotFound } from './common/NotFound';
import { MainContents } from './features/component/MainContents';
import { useAppSelector } from './common/hooks';
import { RootState } from './common/Store';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('7e41ead63be7bee1ea6d4099dbbaba33Tz04MjI4NSxFPTE3MzcwMjkwNjIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const tiny = useMediaQuery('(max-width:1366px)');
  const small = useMediaQuery('(max-width:1920px)');
  const normal = useMediaQuery('(max-width:2560px)');
	const isDark = useAppSelector((state: RootState) => state.menuToggle.darkMode);
  const lightTheme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: 'light',
          background: {
            default: '#fafafa',
            paper: '#fff',
          },
          primary: {
            main: '#05AA8F',
          },
          secondary: {
            main: '#0572AA',
          },
        },
        typography: {
          fontSize: tiny ? 9 : (small ? 11 : (normal ? 14 : 16))
        },
        shape: {
          borderRadius: 8,
        }, 
      }),
    [prefersDarkMode],
  );

  const darkTheme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: 'dark',
          background: {
            default: '#303030',
            paper: '#424242',
          },
          primary: {
            main: '#05AA8F',
          },
          secondary: {
            main: '#0572AA',
          },
        },
        typography: {
          fontSize: tiny ? 9 : (small ? 11 : (normal ? 14 : 16))
        },
        shape: {
          borderRadius: 8,
        }, 
      }),
    [prefersDarkMode],
  );

return (
    <div className="App">
      <ThemeProvider theme={isDark ? darkTheme: lightTheme}>
        <CssBaseline />
        <Routes>
          <Route path='/Login' element={<LoginPage/>} />
          <Route path='/app/*' element={<ProtectedRoute outlet={<MainContents />} authenticationPath={'/Login'} />} />
          <Route path='/' element={<Navigate to='/Login' replace />} />
          <Route path='*' element={<NotFound/>} />
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;
